import gql from 'graphql-tag'

export const coursesAvailable = gql`
  query coursesAvailable{
  coursesAvailable{
    slug
    heading
    description
    status
    lessonsAvailable{
      index
      uri
      next
      heading
      description
      status
      homework
      questions{
        heading
        description
      }
      video{
        code
        provider
      }
      audiocode
    }
  }
}
`
